import { 
    Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, 
    HStack, Text, IconButton, Divider, Box 
  } from "@chakra-ui/react";
  import { CloseIcon } from "@chakra-ui/icons";
  import TradeStatusToggle from "./TradeStatusToggle";
  import TokenStatusToggle from "./TokenStatusToggle";
  
  const TradeSettingsDrawer = ({ isOpen, onClose }) => {
    return (
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
        <DrawerOverlay />
        <DrawerContent p={1}>
          {/* Drawer Header */}
          <DrawerHeader p={0}>
            <HStack justifyContent="space-between">
              <Text fontSize="lg">Trade Settings</Text>
              <IconButton
                icon={<CloseIcon />}
                aria-label="Close Drawer"
                onClick={onClose}
                variant="outline"
              />
            </HStack>
          </DrawerHeader>
  
          {/* Drawer Body */}
          <DrawerBody overflowY="auto" height="auto" p={1} bg="gray.100">
            
            {/* Trade Status Toggle */}
            <Box p={2} bg="white" borderRadius="md">
              <TradeStatusToggle />
            </Box>
  
            {/* Divider */}
            <Divider my={1} />
  
            {/* Token Status Toggle */}
            <Box p={2} bg="white" borderRadius="md">
              <TokenStatusToggle />
            </Box>
  
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  };
  
  export default TradeSettingsDrawer;
  